module.exports = __webpack_public_path__ + "img/30468d0.png";